import React from 'react'
import { Checkbox } from 'components'
import { isMobile } from 'utils/deviceDetector'
import classNames from 'classnames'
import styles from './CheckboxFiltersOptions.module.scss'

const CheckboxFiltersOptions = ({
  options,
  filterKey,
  setBooleanFilter,
  type,
}) => {
  if (!Array.isArray(options)) return null

  return options.map(({ name, checked, value, isVisible }) => {
    if (typeof isVisible === 'boolean' && !isVisible) return null
    return (
      <Checkbox
        key={name + value + type}
        id={name + value + type}
        option={name}
        optionPosition="right-joined"
        onChange={() => setBooleanFilter(filterKey, name)}
        checked={checked}
      />
    )
  })
}

const FiltersCategory = ({
  filterKey,
  options,
  setBooleanFilter,
  justOneColumn,
}) => {
  return (
    <div
      className={classNames({
        [styles['one-column']]: justOneColumn === true || isMobile,
        [styles['two-columns']]: !justOneColumn && !isMobile,
      })}
    >
      {CheckboxFiltersOptions({ options, filterKey, setBooleanFilter })}
    </div>
  )
}

export default React.memo(FiltersCategory)
